import {FC} from 'react';
import Media from 'react-media';
import {shallowEqual} from 'react-redux';

import {useSelector} from '~/store/hooks';

import {FooterMobile} from './parts/FooterMobile';
import {FooterDesktop} from './parts/FooterDesktop';

const queries = {
  small: '(max-width: 767px)',
  large: '(min-width: 768px)',
};

export const Footer: FC = () => {
  const {isStandaloneApplication, isLanding} = useSelector(
    ({app}) => ({
      isStandaloneApplication: app.data.flags.isStandaloneApplication,
      isLanding: app.data.page.isLanding,
    }),
    shallowEqual
  );

  if (isStandaloneApplication || isLanding) {
    return null;
  }

  return (
    <Media queries={queries}>
      {(matches) => (
        <>
          {matches.small && <FooterMobile />}
          {matches.large && <FooterDesktop />}
        </>
      )}
    </Media>
  );
};
